export enum SubscriptionBannerTypeOptions {
  Normal = 'normal',
  Warning = 'warning',
  Information = 'information',
  Danger = 'danger',
}
